const pdfBucketName = process.env.PS_PDF_CACHE_BUCKET

interface GetPdfBucketUrlParams {
  companyId: string
  quoteRev: string
  url: string
  quoteId: string
  view: string
  filename: string
}

export function getPdfBucketUrl({ companyId, quoteId, url, quoteRev, view, filename }: GetPdfBucketUrlParams): string {
  const pdfUrl = `https://${pdfBucketName}.s3.amazonaws.com/${companyId}/${quoteId}/${url}/${quoteRev}/${view}/${filename}`

  return pdfUrl
}

/**
 * The S3 cache url for a quote PDF. Every caller that reads or writes the PDF cache builds the key
 * here, so the in-app dialog, `quotePdf` and `GET /quotes/getPdf` share one cache entry per quote,
 * url, revision and language.
 *
 * The server must build the key it uploads to from the url doc, never take one from the client:
 * a client-chosen key could point at another company's prefix and overwrite its PDF (#25501).
 *
 * A non-English PDF gets its own entry (`<view>-<lang>`), so it never serves an English copy.
 */
export function getPdfCacheUrl({ lang, view, ...params }: GetPdfBucketUrlParams & { lang?: string | null }): string {
  return getPdfBucketUrl({ ...params, view: lang && lang !== 'en' ? `${view}-${lang}` : view })
}

export default getPdfBucketUrl
